import $http from '@/libs/axios'

export type SocialPostGoal =
  | 'بيع'
  | 'تفاعل'
  | 'توعية'
  | 'زيادة المتابعين'
  | 'زيادة الزيارات'
  | 'استقطاب عملاء'
  | 'بناء الثقة'
  | 'تعزيز الولاء'
  | 'ترويج حدث'
  | 'دعم العملاء'
  | 'تعريف بالعلامة'
  | 'جمع آراء'

export type SocialPostTone =
  | 'رسمية'
  | 'ودية'
  | 'حماسية'
  | 'فكاهية'
  | 'إلهامية'
  | 'احترافية'
  | 'عاجلة'
  | 'بسيطة'
  | 'تحفيزية'
  | 'عاطفية'

export type SocialMediaPostGeneratePayload = {
  platform: 'Facebook' | 'Instagram';
  product_description: string;
  target_audience: string;
  goals: SocialPostGoal[];
  tone: SocialPostTone;
  language: 'عربي' | 'إنجليزي' | 'خليط';
  length: 'قصير' | 'متوسط' | 'طويل';
  model?: string | null;
}

export type SocialMediaPostGenerateResponse = {
  text: string;
  model: string;
}

export default class CoreAiApi {
  static async generateSocialMediaPost(
    data: SocialMediaPostGeneratePayload,
  ): Promise<SocialMediaPostGenerateResponse> {
    return (await $http.post('ai/social-media-post', data)).data
  }
}
